export default
[
    {title: "Subscriptions.Label.branchName", dataIndex: "branchName", key: "branchName", responsive: ['md']},
    {title: "Subscriptions.Label.carNumber", dataIndex: "carNumber", key: "carNumber", responsive: ['md']},
]

